import React from "react";
import styled from "styled-components";
import {Grid, ListItem, Typography} from "@material-ui/core";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

interface ViewMoreSemestesButtonProps {
    onClick: () => void;
    open: boolean;
}

const Text = styled(Typography)`
  width: 100%;
  color: #046A38;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const ViewMoreSemestersButton = (props: ViewMoreSemestesButtonProps) => {
    const {onClick, open} = props;
    return (
        <ListItem
            button
            onClick={onClick}
        >
            <Grid
                container
                direction={'column'}
            >
                {!open &&
                    <Grid item>
                        <Text align={'center'}>
                            {'View Previous Semesters'}
                        </Text>
                    </Grid>
                }
                <Grid item>
                    <Text align={'center'}>
                        {open ? <ArrowUpward />  : <ArrowDownward />}
                    </Text>
                </Grid>
            </Grid>
        </ListItem>
    );
};

export default ViewMoreSemestersButton;